import React from 'react';
import { Tag } from 'antd';
import { BtnTable } from '../../../../common/ui/Common';
import { ReactComponent as Edit } from '../../../../common/images/edit.svg';
import { ReactComponent as False } from '../../../../common/images/false.svg';
import { ReactComponent as True } from '../../../../common/images/true.svg';
import c from '../../../../common/ui/theme/Colors';
import IconFormatter from '../../../../pages/private/utils/iconFormatter';
import { dateFormat } from '../../../utils/tableFormatters';

function priceFormatter(column, colIndex, { filterElement }) {
  return (
    <div className="filterBoxTable">
      {column.dataField !== 'Settings' && <Edit style={{ margin: '2px 10px 0 0' }} fill={c.main} />}
      {filterElement}
    </div>
  );
}

function groupFormatter(value, row, roles) {
  return (
    <div className="rolesGroupTable" style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
      {value.map((item) => {
        const role = roles.find((roleItem) => item === roleItem.id);
        if (role) {
          return (
            <Tag
              key={item}
              color="blue"
              style={{
                borderRadius: '6px',
                fontSize: '12px',
                margin: '0',
                textAlign: 'center',
                padding: '4px 8px',
                minHeight: '24px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {role.printname}
            </Tag>
          );
        }
        return null;
      })}
    </div>
  );
}

function checkFormatter(value, revers) {
  return (value
    ? <BtnTable bg="accent" hNone>{!revers ? <False fill="white" /> : <True fill="white" />}</BtnTable>
    : <BtnTable bg="gray" hNone>{!revers ? <True fill="white" /> : <False fill="white" />}</BtnTable>
  );
}

function robotFormatter(value, row) {
  const isRobot = value || false;
  const hasField = Object.prototype.hasOwnProperty.call(row, 'is_robot');

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Tag
        color={isRobot ? 'orange' : 'green'}
        style={{
          borderRadius: '6px',
          fontSize: '12px',
          fontWeight: '500',
          padding: '4px 8px',
          minHeight: '24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          opacity: hasField ? 1 : 0.7,
        }}
      >
        {isRobot ? 'Робот' : 'Человек'}
      </Tag>
    </div>
  );
}

export default function Setting(roles, write, getColumnSearchProps) {
  return {
    columns: [
      {
        dataIndex: 'id',
        title: 'ID',
        fixed: 'left',
        width: 80,
        ...getColumnSearchProps('id', 'ID'),
      },
      {
        dataIndex: 'fio',
        title: 'ФИО',
        fixed: 'left',
        width: 200,
        ...getColumnSearchProps('fio', 'ФИО'),
        headerFormatter: priceFormatter,
      },
      {
        dataIndex: 'username',
        title: 'Логин',
        width: 150,
        ...getColumnSearchProps('username', 'логин'),
        headerFormatter: priceFormatter,
      },
      {
        dataIndex: 'connectedRoles',
        title: 'Роли',
        width: 200,
        render: (value, row) => groupFormatter(value, row, roles),
      },
      {
        dataIndex: 'modified_by_username',
        title: 'Изменен',
        width: 150,
        ...getColumnSearchProps('modified_by_username', 'кем изменён'),

        editable: false,
      },
      {
        dataIndex: 'modified_on',
        title: 'Время изменения',
        width: 160,
        ...getColumnSearchProps('modified_on', 'время изменения'),
        render: (value) => (
          <p>{dateFormat(value)}</p>
        ),
      },
      {
        dataIndex: 'is_robot',
        title: 'Тип пользователя',
        width: 150,
        render: (value, row) => robotFormatter(value, row),
      },
      {
        dataIndex: 'hidden',
        title: 'Работа на АРМ',
        width: 140,
        render: (value) => checkFormatter(value, false),
      },
      {
        dataIndex: 'blocked',
        title: 'Вход через Панель администрирования',
        width: 250,
        render: (value) => checkFormatter(value, false),
      },
      {
        dataIndex: 'Settings',
        fixed: 'right',
        width: 180,

        render: () => IconFormatter({ write, params: true }),
        //  IconFormatter({ filter: true, write: true, params: true })
        // фильтер у пользователя отвечал за показ компонента
        // привязки доп полей к пользователя. Пользователи

      },
    ],
  };
}
